const CHUNK_ERROR_PATTERNS = [
    /ChunkLoadError/i,
    /Loading chunk [\d]+ failed/i,
    /Failed to fetch dynamically imported module/i,
    /Importing a module script failed/i
];

// Match webpack-style hashed JS bundles such as:
// - /vendor.67e70389.js
// - /app.83e909b5.js
// - /js/home.abc12345.chunk.js
const HASHED_BUNDLE_FILE_PATTERN = /(?:^|\/)[\w-]+\.[a-f0-9]{8,}(?:\.chunk)?\.js(?:[?#]|$)/i;

exports.isBundleLoadError = (error) => {

    if (!error) {
        return false;
    }

    const message = String(
        error?.message ||
        error?.reason?.message ||
        error?.error?.message ||
        error ||
        ''
    );

    if (CHUNK_ERROR_PATTERNS.some((pattern) => pattern.test(message))) {
        return true;
    }

    const fileName = String(error?.filename || error?.target?.src || '');

    return HASHED_BUNDLE_FILE_PATTERN.test(fileName);
};
